var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"table",attrs:{"headers":_vm.headers,"items":_vm.batches,"sort-by":'createdAt',"sort-desc":false,"item-key":"id","hide-default-footer":""},on:{"click:row":_vm.goToBatch},scopedSlots:_vm._u([{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.createdAt.toDate().toLocaleString()))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }